import { lazy } from 'react';

const ExternalFileLinkModal = lazy(() =>
  import('modules/DocumentCenter/modals/ExternalFileLinkModal'),
);
const UploadAndRenameModal = lazy(() =>
  import('modules/DocumentCenter/modals/UploadModal'),
);

export default {
  EXTERNAL_FILE_LINK_MODAL: ExternalFileLinkModal,
  FILE_UPLOAD_AND_RENAME: UploadAndRenameModal,
};
